import { render } from "./DocSmartAnts.vue?vue&type=template&id=54b7879e&scoped=true"
import script from "./DocSmartAnts.vue?vue&type=script&lang=js"
export * from "./DocSmartAnts.vue?vue&type=script&lang=js"

import "./DocSmartAnts.vue?vue&type=style&index=0&id=54b7879e&lang=css"
import "./DocSmartAnts.vue?vue&type=style&index=1&id=54b7879e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b7879e"]])

export default __exports__